import {lazy, FC, Suspense, useEffect} from 'react'
import {Route, Routes, Navigate} from 'react-router-dom'
import {MasterLayout} from '../../_metronic/layout/MasterLayout'
import TopBarProgress from 'react-topbar-progress-indicator'
import {DashboardWrapper} from '../pages/dashboard/DashboardWrapper'
import {getCSSVariableValue} from '../../_metronic/assets/ts/_utils'
import {useDispatch} from 'react-redux'
import * as appRedux from '../store/app'
const PrivateRoutes: FC = () => {
    const ProfilePage = lazy(() => import('../modules/profile/ProfilePage'))
    const WizardsPage = lazy(() => import('../modules/wizards/WizardsPage'))
    const AccountPage = lazy(() => import('../modules/accounts/AccountPage'))
    const WidgetsPage = lazy(() => import('../modules/widgets/WidgetsPage'))
    const ChatPage = lazy(() => import('../modules/apps/chat/ChatPage'))
    const ProductsPage = lazy(() => import('../pages/integration/products'))
    const OrderPage = lazy(() => import('../pages/integration/orders'))
    const SettingsPageWrapper = lazy(() => import('../pages/settings/SettingsPageWrapper'))
    const AccountSettingsPage = lazy(() => import('../pages/account-settings'))
    const CompanySettingsPage = lazy(() => import('../pages/company-settings'))
    const StockLocationsPage = lazy(() => import('../pages/stock-locations'))
    const ApiSettingsPage = lazy(() => import('../pages/api-settings'))
    const IntegrationSettingsPage = lazy(() => import('../pages/integration-settings'))
    const LicenceSettingsPage = lazy(() => import('../pages/licence-settings'))
    const ReportsPage = lazy(() => import('../pages/reports'))
    const TicketCreate = lazy(() => import('../pages/tickets/TicketCreate'))
    const TicketList = lazy(() => import('../pages/tickets/TicketList'))
    const TicketReply = lazy(() => import('../pages/tickets/TicketReply'))

  const dispatch = useDispatch()

  useEffect(() => {
    dispatch(appRedux.actions.getSettingLayoutRequest())
  }, [dispatch])

  return (
    <Routes>
      <Route element={<MasterLayout />}>
        {/* Redirect to Dashboard after success login/registartion */}
        <Route path='account/*' element={<Navigate to='/dashboard' />} />
        {/* Pages */}
        <Route path='dashboard' element={<DashboardWrapper />} />
        <Route path='integration/product/*' element={<ProductsPage />} />
        <Route path='integration/order/*' element={<OrderPage />} />
        <Route path='settings' element={<SettingsPageWrapper />} />
        <Route path='settings/account/*' element={<AccountSettingsPage />} />
        <Route path='settings/company' element={<CompanySettingsPage />} />
        <Route path='settings/stock-locations' element={<StockLocationsPage />} />
        <Route path='settings/api-keys/*' element={<ApiSettingsPage />} />
        <Route path='settings/integration/*' element={<IntegrationSettingsPage />} />
        <Route path='settings/licence' element={<LicenceSettingsPage />} />
        <Route path='tickets' element={<TicketList />} />
        <Route path='tickets/create' element={<TicketCreate />} />
        <Route path='tickets/:ticketId' element={<TicketReply />} />
        <Route path='reports' element={<ReportsPage />} />
        {/* Lazy Modules */}
        <Route
          path='crafted/pages/profile/*'
          element={
            <SuspensedView>
              <ProfilePage />
            </SuspensedView>
          }
        />
        <Route
          path='crafted/pages/wizards/*'
          element={
            <SuspensedView>
              <WizardsPage />
            </SuspensedView>
          }
        />
        <Route
          path='crafted/widgets/*'
          element={
            <SuspensedView>
              <WidgetsPage />
            </SuspensedView>
          }
        />
        <Route
          path='crafted/account/*'
          element={
            <SuspensedView>
              <AccountPage />
            </SuspensedView>
          }
        />
        <Route
          path='apps/chat/*'
          element={
            <SuspensedView>
              <ChatPage />
            </SuspensedView>
          }
        />
        {/* Page Not Found */}
        <Route path='*' element={<Navigate to='/error/404' />} />
      </Route>
    </Routes>
  )
}

const SuspensedView: FC = ({children}) => {
  const baseColor = getCSSVariableValue('--bs-primary')
  TopBarProgress.config({
    barColors: {
      '0': baseColor,
    },
    barThickness: 1,
    shadowBlur: 5,
  })
  return <Suspense fallback={<TopBarProgress />}>{children}</Suspense>
}

export {PrivateRoutes}
